import React from 'react';
import './cvObject.scss';

export const CVobject = () => {
  return <div className="object_div"></div>;
};
